import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Eyebrow from "Root/profile/components/common/Eyebrow";
import styles from "./styles.module.scss";
import H2Font from "Root/profile/components/common/H2Font";
import RegFont from "Root/profile/components/common/RegFont";
import CalendarImg from "./images/calendar_checkout_icon.svg";
import Lightning from "./images/lightning.svg";
import RdCheckoutIcon from "./images/rd_checkout_icon.svg";
import ReviewIcon from "./images/review_icon.svg";
import WhyItWorks from "./images/checkout_results_footer_Desktop.jpg";
import WhyItWorksMobile from "./images/checkout_results_footer_Mobile.jpg";
import { useScreenWidth } from "Root/quiz/hooks/useScrollHook";
const reasons = [
    {
        icon: Lightning,
        title: "Automatic Delivery",
        text: " We make it easy with automated deliveries, straight to your door.",
    },
    {
        icon: CalendarImg,
        title: "subscription at your fingertips",
        text: "Change, skip, or pause your subscription at any time",
    },
    {
        icon: RdCheckoutIcon,
        title: "EXCLUSIVE member perks",
        text: "Your subscription includes access to our Registered Dietitians, recipes, nutrition tools, webinar priority access, and rewards for purchases and actions",
        breakTitleOnMobile: true,
    },
    {
        icon: ReviewIcon,
        title: "GOALS CHANGED? NOt a PROBLEM",
        text: "We embrace change. You can always modify your formula to meet any new goals or dietary restrictions",
    },
];
const CheckoutResultsFooter = ({ hideImg }) => {
    const isMobile = useScreenWidth() < 968;
    return (_jsxs("div", { className: [styles.results_footer, hideImg && styles.hide_img].join(" "), children: [_jsx("div", { className: styles.img, children: _jsx("img", { src: isMobile ? WhyItWorksMobile : WhyItWorks, alt: "" }) }), _jsxs("div", { className: styles.copy_wrapper, children: [_jsx(Eyebrow, { children: "why subscribe?" }), _jsx(H2Font, { children: "Gain With Benefits: A Subscriber Exclusive" }), _jsx(RegFont, { children: "When you subscribe, you get more than just our products." }), _jsx("div", { className: styles.grid, children: reasons.map((reason) => (_jsxs("div", { className: styles.grid_item, children: [_jsx("img", { src: reason.icon, alt: "" }), _jsx(Eyebrow, { opacity: 1, children: reason.breakTitleOnMobile && isMobile ? (_jsxs("span", { children: [reason.title.split(" ")[0], _jsx("br", {}), reason.title.split(" ")[1]] })) : (reason.title) }), _jsx(RegFont, { children: reason.text })] }, reason.text))) })] })] }));
};
export default CheckoutResultsFooter;
